import styled from "styled-components";
import { useT } from "@sablier/v2-locales";
import { Ensurance } from "~/client/components/molecules";

const Wrapper = styled(Ensurance)`
  & > *[data-component="card"] {
    background-color: ${(props) => props.theme.colors.dark150};

    *[data-component="frame"] {
      margin-right: calc(${(props) => props.theme.sizes.edge} * 1 / 2);
      color: ${(props) => props.theme.colors.gray400};
      background-color: ${(props) => props.theme.colors.dark300};
    }
    *[data-component="value"] {
      margin-top: 2px;
      p {
        color: ${(props) => props.theme.colors.gray400};
      }
    }
  }
`;

function Note() {
  const { t } = useT();
  return <Wrapper purpose={"duration"} value={t("structs.durationNote")} />;
}

export default Note;
